<template>
    <page title="Data types">
        <p>
            This page describes all available data types used throughout the API.
        </p>
        <section class="type-list type-list-entity">
            <header class="type-list-header">
                <h2 class="type-list-title">Entity types</h2>
            </header>
            <type-info v-for="type in entityTypes" :key="type.id" :type="type"/>
        </section>

        <section class="type-list type-list-compound">
            <header class="type-list-header">
                <h2 class="type-list-title">Compound types</h2>
            </header>
            <type-info v-for="type in compoundTypes" :key="type.id" :type="type"/>
        </section>

        <section class="type-list type-list-primitive">
            <header class="type-list-header">
                <h2 class="type-list-title">Primitive types</h2>
            </header>
            <type-info v-for="type in primitiveTypes" :key="type.id" :type="type"/>
        </section>
    </page>
</template>
<!--suppress JSValidateTypes -->
<script>
  import Page     from '../Layout/Page';
  import TypeInfo from '../Type/TypeInfo';

  export default {
    name: 'Types',

    components: { TypeInfo, Page },

    computed: {

      /**
       * Retrieves all types
       *
       * @returns {Type[]}
       */
      types () {
        return this.$api.types.reduce(( types, type ) => {
          if ( !types.find(otherType => otherType.name === type.name) ) {
            types.push(type);
          }

          return types;
        }, []);
      },

      /**
       * Retrieves all primitive types
       *
       * @returns {Type[]}
       */
      primitiveTypes () {
        return this.types.filter(type => type.primitive);
      },

      /**
       * Retrieves all compound types
       *
       * @returns {Type[]}
       */
      compoundTypes () {
        return this.types.filter(type => type.compound);
      },

      /**
       * Retrieves all entity types
       *
       * @returns {Type[]}
       */
      entityTypes () {
        return this.types.filter(type => type.entity);
      },
    },
  };
</script>

<style scoped>
    .type-list {
        margin-top: 6rem;
    }

    .type-list-header {
        margin-bottom: 1rem;
    }
</style>
